import React from 'react';
import { Box, Typography } from '@mui/material';
import { marketingDisplayFont, marketingPalette } from './marketingSystem';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  maxWidth?: number;
  marginBottom?: number | string;
  inverse?: boolean;
}

const SectionHeading: React.FC<SectionHeadingProps> = ({
  eyebrow,
  title,
  description,
  align = 'left',
  maxWidth = 720,
  marginBottom = 3,
  inverse = false,
}) => {
  const centered = align === 'center';

  return (
    <Box
      sx={{
        textAlign: align,
        mb: marginBottom,
        maxWidth: centered ? maxWidth : 'none',
        mx: centered ? 'auto' : 0,
      }}
    >
      {eyebrow ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: centered ? 'center' : 'flex-start',
            gap: 1.2,
            mb: 1.5,
          }}
        >
          <Typography
            component="span"
            sx={{
              fontSize: '0.7rem',
              fontWeight: 500,
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              color: inverse ? 'rgba(191,219,254,0.85)' : marketingPalette.accent,
              lineHeight: 1,
            }}
          >
            {eyebrow}
          </Typography>
          <Box
            sx={{
              display: { xs: 'none', sm: 'block' },
              width: 48,
              height: 1,
              borderRadius: '999px',
              background: inverse
                ? 'linear-gradient(90deg, rgba(147,197,253,0.5), rgba(255,255,255,0))'
                : 'linear-gradient(90deg, rgba(15,111,255,0.35), rgba(15,111,255,0))',
            }}
          />
        </Box>
      ) : null}
      <Typography
        component="h2"
        sx={{
          mt: 0,
          fontFamily: marketingDisplayFont,
          fontSize: { xs: '1.62rem', md: '2.05rem' },
          fontWeight: 300,
          letterSpacing: '-0.005em',
          color: inverse ? '#ffffff' : marketingPalette.headline,
          lineHeight: 1.18,
          textWrap: 'balance',
        }}
      >
        {title}
      </Typography>
      {description ? (
        <Typography
          sx={{
            mt: 1.25,
            maxWidth,
            mx: centered ? 'auto' : 0,
            fontSize: { xs: '0.95rem', md: '1rem' },
            lineHeight: 1.66,
            color: inverse ? 'rgba(255,255,255,0.78)' : marketingPalette.body,
            textWrap: 'pretty',
          }}
        >
          {description}
        </Typography>
      ) : null}
    </Box>
  );
};

export default SectionHeading;
